import { gql } from '@apollo/client';

export const CREATE_NEW_REPORT_MUTATION = gql`
  mutation CreateNewReport($input: NewReportInput!) {
    createNewReport(input: $input) {
      id
      title
      createdAt
      processingStatus
      createdBy {
        id
        firstName
        lastName
        email
      }
    }
  }
`;

export const CALCULATE_HTML_REPORT_MUTATION = gql`
  mutation CalculateHtmlReport($reportId: ID!, $projectId: ID!) {
    calculateHtmlReport(reportId: $reportId, projectId: $projectId) {
      id
      title
      createdAt
      updatedAt
      reportHtml
      processingStatus
      createdBy {
        id
        firstName
        lastName
        email
      }
      newReportChapter {
        id
        title
        position
        dataPoints {
          id
          title
          value
        }
      }
    }
  }
`;

export const EXPORT_VSME_REPORT_MUTATION = gql`
  mutation ExportVsmeReport($input: VsmeReportExportInput!) {
    exportVsmeReport(input: $input) {
      success
      message
      downloadUrl
    }
  }
`;

export const DELETE_NEW_REPORT_MUTATION = gql`
  mutation DeleteNewReport($id: ID!, $projectId: ID!) {
    deleteNewReport(id: $id, projectId: $projectId) {
      id
    }
  }
`;

export const UPDATE_REPORT_TITLE_MUTATION = gql`
  mutation UpdateReportTitle($id: ID!, $title: String!, $projectId: ID!) {
    updateReportTitle(id: $id, title: $title, projectId: $projectId) {
      id
      title
    }
  }
`;
